import { ADD_GUEST_BULK } from '../actionTypes'

export const addGuestBulk = (data: any) => ({
  type: ADD_GUEST_BULK.name,
  api: {
    url: 'guests/add_guest_bulk',
    data,
  },
})
